const getQueryParams = (params = '', url = ''): string | null => {
  const href = url;
  // this expression is to get the query strings
  const reg = new RegExp(`[?&]${params}=([^&#]*)`, 'i');
  const queryString = reg.exec(href);
  return queryString ? queryString[1] : null;
};

export { getQueryParams };
